import { UserPermission } from '../../permission/enum';
export const companyRoutes = [
    {
        path: 'company',
        name: 'CompanySelect',
        exact: true,
        component: () => import('@/modules/company/views/CompanySelect.vue'),
        meta: {
            breadcrumb: [{ label: 'Company Selection' }],
            permissions: [UserPermission.READ_COMPANY],
        },
    },
];
